import { render, staticRenderFns } from "./subScription.vue?vue&type=template&id=226ffe11&scoped=true"
import script from "./subScription.vue?vue&type=script&lang=js"
export * from "./subScription.vue?vue&type=script&lang=js"
import style0 from "./subScription.vue?vue&type=style&index=0&id=226ffe11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ffe11",
  null
  
)

export default component.exports